export interface InclusionInterface {
  _id: string;
  builderId?: string;
  estateId?: string;
  type: string;
  inclusions: InclusionPackageInterface[]; // Legacy flat list
  categories?: InclusionCategoryInterface[]; // New categorized structure
}

export interface InclusionCategoryInterface {
  name: string;
  items: InclusionPackageInterface[];
}

export interface InclusionPackageInterface {
  name: string;
  description: string[];
  url: string;
}

export type CreateInclusionInterface = Omit<InclusionInterface, "_id">;

export type QueryInclusionInterface = Partial<InclusionInterface>;

export type UpdateInclusionInterface = Partial<InclusionInterface>;

export const inclusionDefault: QueryInclusionInterface = {
  _id: "",
  builderId: "",
  type: "",
  inclusions: [
    {
      name: "",
      description: [],
      url: "",
    },
  ],
};
